var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1329 9.68334C10.1079 9.68334 10.0912 9.68334 10.0662 9.68334C10.0246 9.675 9.96623 9.675 9.91623 9.68334C7.49956 9.60834 5.67456 7.70834 5.67456 5.36667C5.67456 2.98334 7.61623 1.04167 9.99956 1.04167C12.3829 1.04167 14.3246 2.98334 14.3246 5.36667C14.3162 7.70834 12.4829 9.60834 10.1579 9.68334C10.1496 9.68334 10.1412 9.68334 10.1329 9.68334ZM9.99956 2.29167C8.30789 2.29167 6.92456 3.67501 6.92456 5.36667C6.92456 7.03334 8.22456 8.375 9.88289 8.43334C9.92456 8.425 10.0412 8.425 10.1496 8.43334C11.7829 8.35834 13.0662 7.01667 13.0746 5.36667C13.0746 3.67501 11.6912 2.29167 9.99956 2.29167Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1413 18.7917C8.50801 18.7917 6.86634 18.375 5.62467 17.5417C4.46634 16.775 3.83301 15.725 3.83301 14.5833C3.83301 13.4417 4.46634 12.3833 5.62467 11.6083C8.12467 9.94999 12.1747 9.94999 14.658 11.6083C15.808 12.375 16.4497 13.425 16.4497 14.5667C16.4497 15.7083 15.8163 16.7667 14.658 17.5417C13.408 18.375 11.7747 18.7917 10.1413 18.7917ZM6.31634 12.6583C5.51634 13.1917 5.08301 13.875 5.08301 14.5917C5.08301 15.3 5.52467 15.9833 6.31634 16.5083C8.39134 17.9 11.8913 17.9 13.9663 16.5083C14.7663 15.975 15.1997 15.2917 15.1997 14.575C15.1997 13.8667 14.758 13.1833 13.9663 12.6583C11.8913 11.275 8.39134 11.275 6.31634 12.6583Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.39d8585f0db5336ffc2508a352e0d1f4.svg";
export { ForwardRef as ReactComponent };